import { optinQueryOptions } from "@api/optins";
import { QueryClient } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

// @ts-expect-error This style file does exist
import "@grapesjs/studio-sdk/style";

import OptinEditor from "../../../components/OptinEditor/OptinEditor";

export const Route = createFileRoute("/_auth/exchanges/$siteId/$id/edit")({
  component: OptinEditor,

  loader: ({ params, context }) => {
    const { queryClient } = context as { queryClient: QueryClient };
    const { id, siteId } = params;
    return queryClient.fetchQuery(optinQueryOptions(siteId, id));
  },
});
